var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5 mb-5 d-flex flex-column",attrs:{"id":"bc-card-settings","min-height":"600px","width":"100%","outlined":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }